import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { ReqBoardApplyList } from "@/types";
import { AxiosResponse } from "axios";
// import { AxiosResponse } from "axios";

export default {
    async list(stateIdx: number, param: types.ReqBoardActionList): Promise<types.ResBoardActionList> {
        let res = {} as types.ResBoardActionList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/board/action/list/${stateIdx}`, param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async detail(idx: number): Promise<types.ResBoardAction> {
        let res = {} as types.ResBoardAction;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/detail/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async add(idx: number, param: types.ReqBoardAction): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post(`/board/action/add/${idx}`, formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async modify(idx: number, param: types.ReqBoardAction): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            const formData: FormData = new FormData();
            Object.entries(param).forEach(([key, value]) => {
                if (value instanceof File || value instanceof Blob) {
                    formData.append(key, value);
                } else if (value instanceof Array) {
                    value.forEach((item) => {
                        formData.append(key, item);
                    });
                } else if (value !== undefined && value !== null) {
                    formData.append(key, String(value));
                }
            });
            header.headers["Content-Type"] = "multipart/form-data";
            const response = await apiService().post("/board/action/modify/" + idx, formData, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async remove(param: types.ReqIdxList): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/remove", param, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async removeForFile(idx: number, fileIdx: number): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/file/remove/" + idx + "/" + fileIdx, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
        }
        return res;
    },

    async exportExcel(idx: number, param: types.ReqBoardActionForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post(`/board/action/export/excel/${idx}`, param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
